import { AuthorizedService } from "@matchi/api";

export const getUserInfoQueryKey = () => ["userInfo"];

export const getUserInfoQuery = () => ({
  queryKey: getUserInfoQueryKey(),
  queryFn: () => AuthorizedService.getUserInfo(),
});
